import { request } from "@/utils/remoteRequest";

export function searchMainNum(data) {
  return request({
    // url: "/hrIndex/searchMainNum",
    url: "/main/searchMainNum",
    method: "post",
    data,
  });
}

export function searchPostInfoForMain(data) {
  return request({
    // url: "/hrIndex/searchPostInfoForMain",
    url: "/postInfo/searchPostInfoForMain",
    method: "post",
    data,
  });
}

export function searchRankList(data) {
  return request({
    // url: "/hrIndex/searchRankList",
    url: "/main/searchRankList",
    method: "post",
    data,
  });
}

export function searchPostStatistic(data) {
  return request({
    // url: "/hrIndex/searchPostStatistic",
    url: "/main/searchStatisByPostType",
    method: "post",
    data,
  });
}

export function searchPhaseStatistic(data) {
  return request({
    // url: "/hrIndex/searchPhaseStatistic",
    url: "/main/resumeStaticByPhase",
    method: "post",
    data,
  });
}
